import script from "./option.vue?vue&type=script&setup=true&lang=js"
export * from "./option.vue?vue&type=script&setup=true&lang=js"

import "./option.vue?vue&type=style&index=0&id=6b30de02&scoped=true&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b30de02"]])

export default __exports__